"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var _tableResetMixin = require("../tableResetMixin");
/** @class DatePickerMixin */
/** @method */
var DatePickerMixin = function DatePickerMixin(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'Datepicker.backgroundColor',
    weekPaddingTop: 'Datepicker.Week.paddingTop',
    dayHeaderHeight: 'Datepicker.DayHeader.height',
    dayHeaderLineHeight: 'Datepicker.DayHeader.lineHeight',
    dayHeaderBorderBottomWidth: 'Datepicker.DayHeader.borderBottomWidth',
    dayHeaderBorderColor: 'Datepicker.DayHeader.borderColor',
    dayHeaderPaddingTop: 'Datepicker.DayHeader.paddingTop',
    dayHeaderTextAlign: 'Datepicker.DayHeader.textAlign',
    dateHeight: 'Datepicker.Date.height',
    datePadding: 'Datepicker.Date.padding'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      weekPaddingTop = _ref.weekPaddingTop,
      dayHeaderHeight = _ref.dayHeaderHeight,
      dayHeaderLineHeight = _ref.dayHeaderLineHeight,
      _ref$dayHeaderBorderB = _ref.dayHeaderBorderBottomWidth,
      dayHeaderBorderBottomWidth = _ref$dayHeaderBorderB === void 0 ? 1 : _ref$dayHeaderBorderB,
      dayHeaderBorderColor = _ref.dayHeaderBorderColor,
      _ref$dayHeaderPadding = _ref.dayHeaderPaddingTop,
      dayHeaderPaddingTop = _ref$dayHeaderPadding === void 0 ? 0 : _ref$dayHeaderPadding,
      _ref$dayHeaderTextAli = _ref.dayHeaderTextAlign,
      dayHeaderTextAlign = _ref$dayHeaderTextAli === void 0 ? 'center' : _ref$dayHeaderTextAli,
      _ref$dateHeight = _ref.dateHeight,
      dateHeight = _ref$dateHeight === void 0 ? 40 : _ref$dateHeight,
      datePadding = _ref.datePadding;
    return (0, _styledComponents.css)(["background:", ";table{", " margin-top:", ";}table td,table th{height:", "px;padding:", ";box-sizing:border-box;}table thead tr th{height:", "px;line-height:", "px;vertical-align:top;border-bottom:", "px solid ", ";padding-bottom:", ";padding-top:", ";text-align:", ";}table tbody tr:first-child td{padding-top:", ";}", ""], backgroundColor, (0, _tableResetMixin.tableResetMixin)(props), (0, _spaceMixin.spaceMixin)(0.5)(props), dateHeight, datePadding ? datePadding + "px" : (0, _spaceMixin.spaceMixin)(0.5)(props), (0, _spaceMixin.spaceMixin)(dayHeaderHeight, function (space) {
      return space.value + dayHeaderLineHeight + 1;
    })(props), dayHeaderLineHeight, dayHeaderBorderBottomWidth, dayHeaderBorderColor, (0, _spaceMixin.spaceMixin)('xs')(props), dayHeaderPaddingTop, dayHeaderTextAlign, weekPaddingTop ? weekPaddingTop + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.DatePickerMixin = DatePickerMixin;